import { CSSProperties, RefObject, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type StyleProps = CSSProperties & {
  '--height': CSSProperties['height'];
};

export function KalenderWoche({
  isCurrentWeek,
  index,
  startOfWeek,
  endOfWeek,
  gridRef,
  kalenderWocheRef,
}: {
  isCurrentWeek: boolean;
  index: number;
  startOfWeek: string;
  endOfWeek: string;
  gridRef: RefObject<HTMLDivElement | null>;
  kalenderWocheRef: RefObject<HTMLDivElement | null>;
}) {
  const [height, setHeight] = useState(0);
  const { t } = useTranslation();
  const heightOfHeader = 60;

  useEffect(() => {
    if (gridRef.current) {
      setHeight(gridRef.current.offsetHeight);
    }
  }, [gridRef]);

  useEffect(() => {
    if (isCurrentWeek && kalenderWocheRef?.current) {
      kalenderWocheRef.current.scrollIntoView({
        inline: 'center',
        block: 'nearest',
      });
    }
  }, [isCurrentWeek, kalenderWocheRef]);

  return (
    <div className="relative">
      <div
        className={`flex flex-col items-center justify-center ${isCurrentWeek ? 'bg-brand-blue-100 text-white' : 'bg-transparent text-labels-primary'} rounded-md p-0.5`}>
        <div className="text-sm whitespace-nowrap">
          {t('general.date.calendarWeek')} {index + 1}
        </div>
        <div
          className={`hidden md:flex text-xs ${isCurrentWeek ? 'text-white' : 'text-labels-secondary'}`}>
          {startOfWeek + ' – ' + endOfWeek}
        </div>
      </div>
      {isCurrentWeek && (
        <div
          ref={kalenderWocheRef}
          className="absolute flex flex-col justify-center items-center w-full mt-1.5">
          <div className="h-1.5 w-1.5 bg-brand-blue-100 rounded-full" />
          <div
            className="w-px h-(--height) bg-separators-opaque z-10"
            style={
              {
                '--height': height - heightOfHeader + 'px',
              } as StyleProps
            }
          />
        </div>
      )}
    </div>
  );
}
